<template>
  <div class="app-container">
    <el-tabs v-model="activeName" class="demo-tabs">
      <template v-for="(item, index) in warehouseList" :key="item.warehouseId">
        <el-tab-pane :label="item.warehouseName" :name="item.warehouseId">
          <Inventory :data="item" :active-key="activeName" />
        </el-tab-pane>
      </template>
    </el-tabs>
  </div>
</template>

<script setup>
import Inventory from "./inventory.vue";
import { selectInventoryOverview } from "@/api/warehouse/statistics";
import { ref } from "vue";

const warehouseList = ref([]);
const activeName = ref("");

const getWarehouseList = () => {
  selectInventoryOverview().then((res) => {
    warehouseList.value = res.data;
    if (res.data.length > 0) {
      activeName.value = res.data[0].warehouseId;
    }
  });
};

getWarehouseList();
</script>

<style lang="scss" scoped></style>
